// extracted by mini-css-extract-plugin
export default {"charts":"InspectionStatisticCharts_charts__CBJxp","charts__block":"InspectionStatisticCharts_charts__block__yoX26"};